import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-1 min-w-0 flex flex-col overflow-hidden" }
const _hoisted_2 = { class: "h-16 flex items-center px-6 border-b border-border shrink-0 bg-background" }
const _hoisted_3 = { class: "flex-1 overflow-auto p-6 lg:p-8" }
const _hoisted_4 = { class: "max-w-5xl" }
const _hoisted_5 = { class: "flex items-center justify-end mb-6" }
const _hoisted_6 = {
  key: 0,
  class: "!text-sm text-muted-foreground"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestPartnerListFilter = _resolveComponent("RequestPartnerListFilter")!
  const _component_PartnerRequestApprovedListItem = _resolveComponent("PartnerRequestApprovedListItem")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "approved-icon-btn lg:hidden mr-3 p-2 hover:bg-accent text-foreground transition-colors",
            "aria-label": "Open menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              class: "h-5 w-5",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", { d: "M4 5h16" }),
              _createElementVNode("path", { d: "M4 12h16" }),
              _createElementVNode("path", { d: "M4 19h16" })
            ], -1)
          ]))]),
          _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "!text-xl !font-bold !leading-7 text-foreground" }, "Approved Request", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_RequestPartnerListFilter, {
                value: _ctx.filterBy,
                onHandleValueChange: _ctx.setFilter
              }, null, 8, ["value", "onHandleValueChange"])
            ]),
            (_ctx.approvedRequest.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No Data "))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvedRequest, (data, index) => {
                    return (_openBlock(), _createBlock(_component_PartnerRequestApprovedListItem, {
                      key: data.id,
                      data: data,
                      index: index + 1
                    }, null, 8, ["data", "index"]))
                  }), 128))
                ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}